import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'
import { getButtonTestId } from '../Buttons/getButtonTestId'

/** @notExported  */
interface CloseButtonProps {
  /** Action to perform when button is clicked. */
  clickAction: () => void
  /** Tooltip for button. */
  tooltip?: string
  /** Size of the button. */
  size?: 'medium' | 'small' | undefined
  /** Test id of the button. */
  testId?: string
}

/**
 * Close button component.
 *
 * @returns Close button component.
 * @notExported
 * @category Buttons
 */
const CloseButton: React.FC<CloseButtonProps> = ({ clickAction, tooltip, size, testId }) => {
  const { t } = useTranslation()
  const resolvedTestId = getButtonTestId({ fallback: 'button-close', label: tooltip ?? t('close'), testId })

  const getButton = () => {
    return (
      <IconButton data-testid={resolvedTestId} sx={{ float: 'right' }} onClick={() => clickAction()} size={size}>
        <CloseIcon />
      </IconButton>
    )
  }
  return <Tooltip title={tooltip ?? (t('close') as string)}>{getButton()}</Tooltip>
}

export default CloseButton
